import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Data } from 'src/app/helper/datastore';
import { AuthService } from 'src/app/services/auth.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../builders/loader/loader.component';
import { NotificationComponent } from '../notification/notification.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() accountType: any;
  @Input() type: any = 'mainHeader';
  @Input() navScreen: any;
  @Input() isEmailFlag: any=true;
  @Input() firstNameToTrigger: any;
  @ViewChild('forgotPasswordModal')
  forgotPasswordModal: any;
  @ViewChild('successModal')
  successModal:any
  @ViewChild('basicModal')
  basicModal: any;
  @ViewChild('otpModal')
  public otpModal: any;
  isEmployeeOTPSent: any;
  custId: any;
  userName: any;
  emailOtpForm: FormGroup;
  LoaderComponent: any;
  _contactEmailOTPSubmitted: any = false;
  _changePasswordSubmitted: any = false;
  isError: any = false;
  _message: any ='' 
  isResendButtonShow: any = false;
  resetOTPResponse: any = "";
  interval: any;
  otpTimer: any = 30;
  typeId: any =1;
  isChangePassword: any = false;

  message: any = [];
  popupIsVisibleTrigger: any = false;
  popupResponseObject: any = [];
  demoAccountType: any = 'free';
  isClicked: any = false;
  isPasswordMatched: any = true;
  _showChangePassword: any;
  _showPassword: any;
  loginData: any;
  employeePagePermission: any[] = [];
  unpaidReqData:any;
  responseMessage:any;
  loggedInCustomers: any[];

  constructor(
    public router: Router,
    public auth: AuthService,
    public messagingService: MessagingService,
    public service: WebRequestService,
    private data: Data,
    public dialog: MatDialog

  ) {
   
  }

  ngOnInit(): void {
    // console.log(this.isEmailFlag);
    this.messagingService.receiveMessage();
    this.messagingService.currentMessage.subscribe((res) => {
      // console.log(res);
      if (res) {
        this.message.push(res['notification']);
      }

      // console.log(this.message);
    });
    this.data.getStoreData('empData')
    .then((dataRes: any) => {
      this.custId = JSON.parse(dataRes).empID;
      this.userName = JSON.parse(dataRes).userName;
      this.loginData = JSON.parse(dataRes);
      if (this.loginData) {
        this.LoaderComponent = LoaderComponent;
        this.service.getPagePermissionsData(this.loginData['employeeID']).then((res) => {
          if (res['statusCode'] === 200) {
            this.LoaderComponent = '';
            this.employeePagePermission = res['result']['employeeAllowedPages'];
            this.getEmployeeNotification(this.loginData['employeeID'])
            this.loggedInNotification();
          }
        })
        .catch((err) => {
          this.LoaderComponent = '';
          console.error(err)});
      }
    })
    .catch((err) => console.error(err));

    // console.log(this.message);
    this.initemailOTPForm()
  }
  loggedInNotification(){
    this.LoaderComponent = LoaderComponent;
    this.unpaidReqData = {
      flag: 'UNPD',
      startindex: 1,
      endIndex: 10
    }
    this.service.getEmpProfiles(this.unpaidReqData).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = "";
           this.loggedInCustomers = [];
          res['result'].map((val) => {
            this.loggedInCustomers.push(val);
         })
  }
  else {
    this.LoaderComponent = '';
    this.responseMessage = res['message'];
  }
})
  }
  getEmployeeNotification(empID){
    let data = {
        empID: empID,
        displayType: 0,
        notificationID: 0,
        categoryID: '20,21,22,24,25,26,8',
        custID: 0,
        startIndex: 1,
        endIndex: 3
    }
    this.service.getEmployeeNotifications(data).then((res)=>{
      // console.log(res)
      if(res['statusCode'] === 200){
        res['result'].map((val) => {
          this.message.push(val);
        });
      }
    }).catch((err) => { console.log(err)})
  }
  getLoggedInUsers(){
          const dialogRef = this.dialog.open(NotificationComponent, {
            maxWidth: '90vw',
            width: '100%',
            height: '91%',
            disableClose: true,
            data: {
              allData: this.loggedInCustomers,
              type: 2,
              reqData: this.unpaidReqData
            }
          })
  }

  navigateToEditviewDashboard(data){
    this.router.navigate([`/editViewDashBoard`,{id: data?.cust_ID,type:'educational'}]);

    let dataObj = {
      empID: this.loginData['employeeID'],
      displayType: 2,
      notificationID: data?.notificationID,
      categoryID: '20,21,22,24,25,26,8',
      custID: data?.cust_ID,
      startIndex: 1,
      endIndex: 3
  }
  this.service.getEmployeeNotifications(dataObj).then((res)=>{
    console.log(res)
    // res['result'].map((val) => {
    //   this.message.push(val);
    // });
  })
  }
  getAllNotifications(){

    let dataObj = {
      empID: this.loginData['employeeID'],
      displayType: 1,
      notificationID: 0,
      categoryID: '20,21,22,24,25,26,8',
      custID: 0,
      startIndex: 1,
      endIndex: 10
  }
  this.LoaderComponent = LoaderComponent;
  this.service.getEmployeeNotifications(dataObj).then((res)=>{
    console.log(res)
    if(res['statusCode'] === 200){
      let dataToSend = [];
      res['result'].map((val) => {
        dataToSend.push(val);
      });
      this.LoaderComponent='';
      const dialogRef = this.dialog.open(NotificationComponent, {
        maxWidth: '90vw',
        width: '100%',
        height: '91%',
        disableClose: true,
        data: {
          notificationData: dataToSend,
          type: 1,
          notiReqData: dataObj
        }
      })
    }
    else {
        this.LoaderComponent = '';
    }
  })
  }
  navigateToDashboard() {
    this.isClicked = true
    this.router.navigate(["/dashboard"])
  }

  redirectToPages(menu) {
    if(menu.pageID === 1) {
      switch(menu.id) {
        case 1:
          this.router.navigateByUrl('customerregistration');
          break;
        case 2:
          this.router.navigateByUrl('editViewProfile');
          break;
        case 3:
          this.navigateToRegistrationProfileValidation();
          break;  
        case 5:
          this.navigateToPaymentDetails();
          break;
        case 7:
          this.router.navigateByUrl('viewProfilePage');
          break;  
      }
    } else if (menu.pageID === 2) {
      switch(menu.id) {
        case 8:
          this.navigateToSearchProfile('general','');
          break;
        case 9:
          this.navigateToSearchProfile('advanced','');
          break;
        case 10:
          this.navigateToSearchProfile('keyword','');
          break;
        case 21:
          this.navigateToSearchProfile('arrival', '')

      } 
    } else if (menu.pageID === 3) {
      switch(menu.id) {
        case 11:
          this.router.navigateByUrl('marketingSlideShow');
          break;
        case 12:
          this.router.navigateByUrl('matchfollowup');
          break;
        case 13:
          this.router.navigateByUrl('matchMeeting');
          break;
        case 14:
          this.router.navigateByUrl('guestTicketCreation');
          break;
        case 15:
          this.router.navigateByUrl('lst');
          break;
        case 22:
          this.router.navigateByUrl('myprofile');
          break
        case 23:
          this.router.navigateByUrl('myprofileold')

      }
    } else if (menu.pageID === 4) {
      switch(menu.id) {
        case 16:
          this.router.navigateByUrl('profileAssign');
          break;
        case 17:
          this.router.navigateByUrl('marketingReassign');
          break;
      }
    } else if (menu.pageID === 5) {
      switch(menu.id) {
        case 19:
          this.router.navigateByUrl('update-branch');
          break;
        case 20:
            this.router.navigateByUrl('broker-management');
            break;  
        case 25:
          this.router.navigateByUrl('master-page');
          break;
      }
    } else if (menu.pageID === 6) {
      switch(menu.id) {
        case 27:
          this.router.navigate(['reports/utm-reports']);
          break; 
        case 28:
          this.router.navigateByUrl('reports/failed-registration-reports');
          break;
        case 29:
          this.router.navigateByUrl('reports/employee-performance-report');
          break;
        case 30:
          this.router.navigateByUrl('reports/temp-delete-reports');
          break;
        case 31:
          this.router.navigateByUrl('reports/email-bounced-report');
          break;
      }
    }
  }

  subMenuRedirection(menu) {
    if(menu.menuItemID === 4) {
      switch(menu.id) {
        case 1:
          this.router.navigateByUrl('expressInterest');
          break;
        case 2:
          this.router.navigateByUrl('communicationLog');
          break;
        case 6: 
          this.router.navigateByUrl('serviceSlideShow');
          break;
      }
    } else if(menu.menuItemID === 6) {
      switch(menu.id) {
        case 3:
          this.router.navigateByUrl('paymentOffers');
          break;
        case 4:
          this.router.navigateByUrl('paymentAuthorization');
          break;
      }
    } else if(menu.menuItemID === 18) {
      switch(menu.id) {
        case 5:
          this.router.navigateByUrl('employee-permission');
          break;
          case 7:
            this.router.navigateByUrl('edit-view-employees');
            break;
          case 10:
            this.router.navigateByUrl('employee-call-reports');
            break; 
          case 11:
            this.router.navigateByUrl('employee-activity-points');
            break;
      }
    } else if(menu.menuItemID === 24){
      switch(menu.id){
        case 9:
          this.router.navigateByUrl('upload-view-sa')
      }
    }
  }

  showPopup() {
    let array = this.firstNameToTrigger.split(' ');
    let name;
    array.length > 0 ? (name = array[0]) : (name = this.firstNameToTrigger);
    this.popupResponseObject = {
      response: '',
      name: 'Hey ' + name + '!! Please Verify Your Email',
      header: '',
    };
    this.popupIsVisibleTrigger = true;
  }

  closeEventPopup(event) {
    if (event) this.popupIsVisibleTrigger = false;
  }
  navigateToRegistrationProfileValidation() {
    this.router.navigateByUrl('registrationprofile');
  }
  navigateToMyAccount() {
    this.router.navigateByUrl('membership');
  }
  navigateToPaymentDetails(){
    this.router.navigateByUrl('paymentDetails')
  }
  logout() {
    if(this.isChangePassword){
      this.basicModal.hide();
      this.LoaderComponent = LoaderComponent;
      this.auth
      .forgotPassword({username:this.userName})
      .then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = '';
          this.forgotPasswordModal.hide()
          this.custId = response['result'];
          this.resetOTPResponse = response['message'];
          this.otpModal.show()
          const otpCode =
            this.emailOtpForm.value.otp1 +
            '' +
            this.emailOtpForm.value.otp2 +
            '' +
            this.emailOtpForm.value.otp3 +
            '' +
            this.emailOtpForm.value.otp4 +
            '' +
            this.emailOtpForm.value.otp5;

          const otpCodeNumber = Number(otpCode);

         
        } else {
          this.LoaderComponent = '';
          this._message = response['message'];
          this.isError=true;
        }
      })
      .catch((err) => {
        //Needs to remove
        this.LoaderComponent = ''
      });
    }else{
      this.auth.logout();
      this.service.enableNav = false;
      sessionStorage.setItem('enableNav', JSON.stringify(this.service.enableNav))
      localStorage.removeItem('popupShown');
      sessionStorage.removeItem('empData');
      sessionStorage.removeItem('loginData');
      sessionStorage.removeItem('empId');
    }
   
  }
  navigateToSearch() {
    this.router.navigateByUrl('search');
  }

  showBasicModal(type){
    if(type=='changePassword'){
      this.isChangePassword=true
    } else {
      this.isChangePassword=false;
    }
    this.basicModal.show()
  }

  initemailOTPForm() {
    this.emailOtpForm = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
      ]),
      confirmPassword: new FormControl(null, [
        Validators.required,
      ]),
      // tslint:disable-next-line
      otp1: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp2: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp3: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp4: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
      otp5: new FormControl(null, [
        Validators.required,
        Validators.maxLength(1),
        Validators.pattern('^[0-9]{1,1}$'),
      ]),
    });

  
  }


  lastInput(event, previousInput, formName) {
    const input = event.target;
    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
      previousInput.focus();
    } else {
    }
    if (input.value.length >= input.maxLength) {
      input.value.length >= 1
        ? (input.value = input.value.slice(0, input.maxLength))
        : '';
      input.value = input.value.slice(0, 1);
      this.emailOtpForm.get(formName).setValue(Number(input.value));
    }
  }

  emailEditForm: FormGroup;

  get emailVal() {
    return this.emailEditForm.controls;
  }
  omit_special_char_withNumbers_password1(event) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = event.target;
    const length = input.value.length;
    var k;

    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (/^\s*\S\s*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57)
      );
    }
  }

  ComparePassword() {
    if (
      this.emailOtpForm.value.password &&
      this.emailOtpForm.value.confirmPassword
    ) {
      this.isPasswordMatched =
        this.emailOtpForm.value.password ===
        this.emailOtpForm.value.confirmPassword;
    } else {
      this.isPasswordMatched = true;
    }
  }
  showChangePassword() {
    this._showChangePassword = !this._showChangePassword;
  }
  showPassword() {
    this._showPassword = !this._showPassword;
  }

  verifyEmailOtp() {
    this.LoaderComponent = LoaderComponent;
    this._contactEmailOTPSubmitted =true;
    if (this.emailOtpForm.invalid) {
      this.LoaderComponent = '';
      return;
    }
    const otpCode =
      this.emailOtpForm.value.otp1 +
      '' +
      this.emailOtpForm.value.otp2 +
      '' +
      this.emailOtpForm.value.otp3 +
      '' +
      this.emailOtpForm.value.otp4 +
      '' +
      this.emailOtpForm.value.otp5;
    const otpCodeNumber = Number(otpCode);
    if (
      this.emailOtpForm.value.password !=
        this.emailOtpForm.value.confirmPassword &&
      !this.isPasswordMatched
    ) {
      this.LoaderComponent = '';
      return;
    }
    let data = {
      empID: String(this.custId),
      verificationCode: String(otpCodeNumber),
      newPassword: String(this.emailOtpForm.value.confirmPassword),
    };

    this.service
      .saveNewPasswordAsync(data)

      .then((response) => {
        this.LoaderComponent = '';
        this.data._errorMessage = response['message'];
        if (response['statusCode'] === 200) {
         this.forgotPasswordModal.hide();
          this.isEmployeeOTPSent = false; 
          this._contactEmailOTPSubmitted = false;
          this.emailOtpForm.reset();
         
          this.successModal.show()
        
        }
        if (response['statusCode'] === 417) {
          this.isError =true;
          this._message = response['message'];
          this._changePasswordSubmitted = false;
          this._contactEmailOTPSubmitted = false;
        }

        this._changePasswordSubmitted = false;
        this._contactEmailOTPSubmitted = false;
      })
      .catch((err) => {
        // Needs to remove
        this.LoaderComponent = '';
      });
  }
  omit_special_char_withNumbers_custom_backspace(event, previousInput) {}

  omit_special_char_withNumbers_custom(event) {
    const charCode = event.which ? event.which : event.keyCode;
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (/^[0-9\s]*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57)
      );
    }
  }


  resendOTP(custId:any ,typeId:any) {
    
    this.LoaderComponent = LoaderComponent
    this.service.resendMobileOTP(custId,typeId).then((response) => {
      //this.isResendButtonShow = false;
    this.isResendButtonShow = true;
    this.startOtpTimer();
      this.LoaderComponent = '';
      this.resetOTPResponse = response['message'];
      this.otpModal.show();
      setTimeout(() => {
        this.otpModal.hide();
      }, 2000);
     
    }).catch((err) => {
       this.LoaderComponent = '';
    });;
  }

  onFocusInput(event) {
    const input = event.target;
    const length = input.value.length;

    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
    } else {
    }
  }
  onInputEntry(event, nextInput, previousInput, formName) {
    const input = event.target;
    const length = input.value.length;

    const charCode = event.inputType;
    if (charCode === 'deleteContentBackward') {
      previousInput != undefined ? previousInput.focus() : '';
    } else {
    }

    if (input.value.length >= input.maxLength) {
      input.value.length >= 1
        ? (input.value = input.value.slice(0, input.maxLength))
        : '';
      input.value = input.value.slice(0, 1);
      nextInput.focus();
      this.emailOtpForm.get(formName).setValue(Number(input.value));
    }

    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (k === 8) {
    }
    if (/^[0-9\s]*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57) ||
        length > 1
      );
    }
  }
  get fval() {
    return this.emailOtpForm.controls;
  }
  resetModals(){
    this.forgotPasswordModal.hide();
    this.isEmployeeOTPSent = false;
    this.emailOtpForm.reset();
    clearInterval(this.interval);
    this.otpTimer = 30;
    this.isResendButtonShow = false;
  }

  startOtpTimer() {
    this.interval = setInterval(() => {
      if (this.otpTimer > 0) {
        this.otpTimer--;
      } else {
        clearInterval(this.interval);
        this.isResendButtonShow = false;
        this.otpTimer = 60;
      }
    }, 1000);
  }
  
  closeOTPModal(){
    this.otpModal.hide();
    this.forgotPasswordModal.show();
    this.isEmployeeOTPSent = true
    this._contactEmailOTPSubmitted =  false;
    
  }

  hideSuccessModal(){
    this.successModal.hide();
    this.isChangePassword=false;
    this.logout()
  }
  navigateToSearchProfile(type,id){
    console.log(type)
    this.router.navigate([`/searchprofile`,{id: id,type:type}]);
    
    // switch(type){
    //   case 'general':
    //     this.router.navigate([`/searchprofile`,{id: id,type:'general'}]);
    //   break;
    //   case 'advanced':
    //     this.router.navigate([`/searchprofile`,{id: id,type:'advanced'}]);
    //   break;
    // }
    // this.router.navigate([`/searchprofile`,{id: id,type:type}]);
  }

}
